import { render, staticRenderFns } from "./WidgetMain.vue?vue&type=template&id=a52b3cde&"
import script from "./WidgetMain.vue?vue&type=script&lang=js&"
export * from "./WidgetMain.vue?vue&type=script&lang=js&"
import style0 from "./WidgetMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports